// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_create_separate_order_for_each_position1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create separate order for each position`)
};

const en_us2_create_separate_order_for_each_position1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create separate order for each position`)
};

const de_de2_create_separate_order_for_each_position1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate Bestellung für jede Position erstellen`)
};

const en_create_separate_order_for_each_position1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create separate order for each position`)
};

const de_create_separate_order_for_each_position1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate Bestellung für jede Position erstellen`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const create_separate_order_for_each_position1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.create_separate_order_for_each_position1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("create_separate_order_for_each_position1", locale)
	if (locale === "en-GB") return en_gb2_create_separate_order_for_each_position1(inputs)
	if (locale === "en-US") return en_us2_create_separate_order_for_each_position1(inputs)
	if (locale === "de-DE") return de_de2_create_separate_order_for_each_position1(inputs)
	if (locale === "en") return en_create_separate_order_for_each_position1(inputs)
	return de_create_separate_order_for_each_position1(inputs)
};
export { create_separate_order_for_each_position1 as "Create separate order for each position" }